import { PERF_DEBUG } from "../debug-flags";

let started = false;

/**
 * Start a PerformanceObserver for longtask entries (tasks > 50ms on the main
 * thread). Logs each entry to console when PERF_DEBUG is enabled.
 *
 * Safe to call multiple times — only the first call starts the observer. Also
 * safe in environments without PerformanceObserver or the "longtask" entry
 * type (e.g. older WebKit, Node) — it no-ops.
 */
export function startLongTaskObserver(): void {
  if (started) return;
  if (!PERF_DEBUG) return;
  if (typeof PerformanceObserver === "undefined") return;

  const supported = (
    PerformanceObserver as unknown as { supportedEntryTypes?: string[] }
  ).supportedEntryTypes;
  if (supported && !supported.includes("longtask")) return;

  try {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        const attribution = (
          entry as PerformanceEntry & {
            attribution?: Array<{ name?: string; containerType?: string }>;
          }
        ).attribution;
        const src =
          attribution && attribution.length > 0
            ? `${attribution[0]?.containerType ?? "?"}:${attribution[0]?.name ?? "?"}`
            : "unknown";
        console.debug(
          `[perf:longtask] ${Math.round(entry.duration)}ms src=${src}`,
        );
      }
    });
    observer.observe({ entryTypes: ["longtask"] });
    started = true;
  } catch {
    // Observer not supported — silently no-op.
  }
}
